<template>
  <div class="share-report-day">
    <ListPageLayout :loading="tableLoading">
    <template #filter>
        <!-- 查询条件区域 -->
            <div class="searchbox">
              <form class="form-inline">
                <div class="form-group">
                  <el-select 
                    v-model="searchForm.parkId" 
                    placeholder="请选择停车场"
                    clearable
               
                    @change="watchParkChange"
                  >
                    <el-option
                      v-for="item in parkList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div>
                <div class="form-group">
                  <el-select 
                    v-model="searchForm.spaceId" 
                    placeholder="请选择车位"
                    clearable
                 
                  >
                    <el-option
                      v-for="item in spaceList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div>
                <div class="form-group">
                  <el-date-picker
                    v-model="searchForm.dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
           
                  />
                </div>
                <div class="form-group others">
                  <span class="search_btn">
                    <el-button
                      id="search_btn"
                      type="primary"
                      size="small"
                      :loading="tableLoading"
                      :disabled="tableLoading"
                      @click="handleSearch"
                    >
                      {{ tableLoading ? "查询中..." : "查询" }}
                    </el-button>
                  </span>
                  <span class="search_btn">
                    <el-button
                      @click="handleReset"
                      type="button"
                      class="btn btn-default"
                    >
                      导出
                    </el-button>
                  </span>
                </div>
              </form>
            </div>
    </template>

      <el-table 
              :data="tableData" 
              border 
              stripe
              style="width: 100%"
              height="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="tableCellStyle"
              highlight-current-row
              show-summary
              :summary-method="getSummaries"
            >
              <el-table-column prop="date" label="时间" width="100" min-width="100" />
              <el-table-column prop="totalOrderAmount" label="订单总金额" width="130" min-width="130">
                <template slot-scope="scope">
                  ¥{{ scope.row.totalOrderAmount || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="settledOrderAmount" label="已分账订单总金额" width="160" min-width="160">
                <template slot-scope="scope">
                  ¥{{ scope.row.settledOrderAmount || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="platformShare" label="平台分账" width="120" min-width="120">
                <template slot-scope="scope">
                  ¥{{ scope.row.platformShare || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="propertyShare" label="物业分账" width="120" min-width="120">
                <template slot-scope="scope">
                  ¥{{ scope.row.propertyShare || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="personalShare" label="个人分账" width="120" min-width="120">
                <template slot-scope="scope">
                  ¥{{ scope.row.personalShare || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="totalTimeoutAmount" label="超时总金额" width="130" min-width="130">
                <template slot-scope="scope">
                  ¥{{ scope.row.totalTimeoutAmount || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="settledTimeoutAmount" label="已分账超时订单总金额" width="160" min-width="160">
                <template slot-scope="scope">
                  ¥{{ scope.row.settledTimeoutAmount || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="timeoutPlatformShare" label="超时平台分账" width="130" min-width="130">
                <template slot-scope="scope">
                  ¥{{ scope.row.timeoutPlatformShare || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="timeoutPropertyShare" label="超时物业分账" width="130" min-width="130">
                <template slot-scope="scope">
                  ¥{{ scope.row.timeoutPropertyShare || '0.00' }}
                </template>
              </el-table-column>
              <el-table-column prop="timeoutPersonalShare" label="超时个人分账" width="130" min-width="130">
                <template slot-scope="scope">
                  ¥{{ scope.row.timeoutPersonalShare || '0.00' }}
                </template>
              </el-table-column>
            </el-table>

      <template #pagination>
        <Page v-on:pagination="receivePaginationData"></Page>
      </template>
    </ListPageLayout>
  </div>
</template>

<script>
import { get, post } from '@/api/http'
import { 
  shareReportDayStatistics, 
  shareReportDayList,
  parkList,
  getSpaceList
} from '@/api/url'
import Page from "@/page/commons/page";
import ListPageLayout from '@/page/commons/ListPageLayout.vue';
export default {
  name: 'ShareReportDay',
  data() {
    return {
      tableLoading: false,
      // 查询表单
      searchForm: {
        parkId: '',
        spaceId: '',
        dateRange: [] // 新增时间范围
      },
      
      // 车场列表
      parkList: [],
      
      // 车位列表
      spaceList: [],

      // 统计数据
      statistics: {
        totalOrderAmount: '0.00',
        settledOrderAmount: '0.00',
        platformShare: '0.00',
        propertyShare: '0.00',
        personalShare: '0.00',
        totalTimeoutAmount: '0.00',
        settledTimeoutAmount: '0.00',
        timeoutPlatformShare: '0.00',
        timeoutPropertyShare: '0.00',
        timeoutPersonalShare: '0.00'
      },

      // 表格数据
      tableData: [],
      loading: false,

      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  components: {
    ListPageLayout,
    Page,
  },
  mounted() {
    this.getParkList()
    this.getStatistics()
    this.getTableData()
  },
  
  computed: {
    // 表头样式
    tableHeaderStyle() {
      return {
        backgroundColor: '#f8f9fa',
        color: '#2c3e50',
        fontWeight: '600',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    // 单元格样式
    tableCellStyle() {
      return {
        padding: '12px 0'
      }
    }
  },
  
  methods: {

    // 获取车场列表
    async getParkList() {
      try {
        // 测试数据
        this.parkList = [
          { id: 1, name: '智慧停车场A' },
          { id: 2, name: '商业中心停车场B' },
          { id: 3, name: '住宅区停车场C' },
          { id: 4, name: '办公大楼停车场D' },
          { id: 5, name: '购物中心停车场E' }
        ]
        
        // 实际API调用（注释掉）
        // const response = await get(parkList(), {
        //   page: 1,
        //   pageSize: 1000
        // })
        // if (response.data && response.data.records) {
        //   this.parkList = response.data.records.map(item => ({
        //     id: item.id,
        //     name: item.parkingName
        //   }))
        // }
      } catch (error) {
        console.error('获取车场列表失败:', error);
      }
    },

    // 获取车位列表
    async getSpaceList() {
      try {
        if (!this.searchForm.parkId) {
          this.spaceList = []
          return
        }
        
        // 测试数据 - 根据车场ID返回不同的车位
        const spaceData = {
          1: [
            { id: 101, name: 'A区-001' },
            { id: 102, name: 'A区-002' },
            { id: 103, name: 'A区-003' },
            { id: 104, name: 'A区-004' },
            { id: 105, name: 'A区-005' }
          ],
          2: [
            { id: 201, name: 'B区-001' },
            { id: 202, name: 'B区-002' },
            { id: 203, name: 'B区-003' },
            { id: 204, name: 'B区-004' }
          ],
          3: [
            { id: 301, name: 'C区-001' },
            { id: 302, name: 'C区-002' },
            { id: 303, name: 'C区-003' },
            { id: 304, name: 'C区-004' },
            { id: 305, name: 'C区-005' },
            { id: 306, name: 'C区-006' }
          ],
          4: [
            { id: 401, name: 'D区-001' },
            { id: 402, name: 'D区-002' },
            { id: 403, name: 'D区-003' }
          ],
          5: [
            { id: 501, name: 'E区-001' },
            { id: 502, name: 'E区-002' },
            { id: 503, name: 'E区-003' },
            { id: 504, name: 'E区-004' },
            { id: 505, name: 'E区-005' }
          ]
        }
        
        this.spaceList = spaceData[this.searchForm.parkId] || []
        
        // 实际API调用（注释掉）
        // const response = await get(getSpaceList(), {
        //   parkingId: this.searchForm.parkId,
        //   page: 1,
        //   pageSize: 1000
        // })
        // 
        // if (response.data && response.data.records) {
        //   this.spaceList = response.data.records.map(item => ({
        //     id: item.id,
        //     name: item.spaceName || item.spaceNum
        //   }))
        // }
      } catch (error) {
        console.error('获取车位列表失败:', error);
      }
    },

    // 获取统计数据
    async getStatistics() {
      try {
        // 测试数据 - 根据查询条件返回不同的统计数据
        let statistics = {
          totalOrderAmount: '0.00',
          platformShare: '0.00',
          propertyShare: '0.00',
          personalShare: '0.00',
          totalTimeoutAmount: '0.00',
          timeoutPlatformShare: '0.00',
          timeoutPropertyShare: '0.00',
          timeoutPersonalShare: '0.00'
        }
        
        // 根据查询条件生成数据
        let multiplier = 1
        if (this.searchForm.parkId) {
          multiplier = this.searchForm.parkId * 0.5 + 0.5
        }
        
        // 时间范围影响
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          const startDate = new Date(this.searchForm.dateRange[0])
          const endDate = new Date(this.searchForm.dateRange[1])
          const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24))
          multiplier *= Math.min(daysDiff / 7, 2) // 最多2倍，最少0.14倍
        }
        
        const baseAmount = 1000 * multiplier
        
        statistics = {
          totalOrderAmount: (baseAmount + Math.random() * 5000).toFixed(2),
          settledOrderAmount: (baseAmount * 0.8 + Math.random() * 1000).toFixed(2),
          platformShare: (baseAmount * 0.2 + Math.random() * 1000).toFixed(2),
          propertyShare: (baseAmount * 0.5 + Math.random() * 2500).toFixed(2),
          personalShare: (baseAmount * 0.3 + Math.random() * 1500).toFixed(2),
          totalTimeoutAmount: (baseAmount * 0.1 + Math.random() * 500).toFixed(2),
          settledTimeoutAmount: (baseAmount * 0.07 + Math.random() * 100).toFixed(2),
          timeoutPlatformShare: (baseAmount * 0.02 + Math.random() * 100).toFixed(2),
          timeoutPropertyShare: (baseAmount * 0.05 + Math.random() * 250).toFixed(2),
          timeoutPersonalShare: (baseAmount * 0.03 + Math.random() * 150).toFixed(2)
        }
        
        Object.assign(this.statistics, statistics)
        
        // 实际API调用（注释掉）
        // const params = {}
        // if (this.searchForm.parkId) {
        //   params.parkId = this.searchForm.parkId
        // }
        // if (this.searchForm.spaceId) {
        //   params.spaceId = this.searchForm.spaceId
        // }
        // if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        //   params.startDate = this.searchForm.dateRange[0]
        //   params.endDate = this.searchForm.dateRange[1]
        // }
        // 
        // const response = await get(shareReportDayStatistics(), params)
        // 
        // if (response.data) {
        //   Object.assign(this.statistics, {
        //     totalOrderAmount: response.data.totalOrderAmount || '0.00',
        //     settledOrderAmount: response.data.settledOrderAmount || '0.00',
        //     platformShare: response.data.platformShare || '0.00',
        //     propertyShare: response.data.propertyShare || '0.00',
        //     personalShare: response.data.personalShare || '0.00',
        //     totalTimeoutAmount: response.data.totalTimeoutAmount || '0.00',
        //     settledTimeoutAmount: response.data.settledTimeoutAmount || '0.00',
        //     timeoutPlatformShare: response.data.timeoutPlatformShare || '0.00',
        //     timeoutPropertyShare: response.data.timeoutPropertyShare || '0.00',
        //     timeoutPersonalShare: response.data.timeoutPersonalShare || '0.00'
        //   })
        // }
      } catch (error) {
        console.error('获取统计数据失败:', error);
      }
    },

    // 获取表格数据
    async getTableData() {
      this.loading = true;
      this.tableLoading = true;
      try {
        // 测试数据 - 生成模拟的表格数据
        const generateTestData = () => {
          const data = []
          const today = new Date()
          
          // 确定日期范围
          let startDate = new Date(today)
          let endDate = new Date(today)
          
          if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
            startDate = new Date(this.searchForm.dateRange[0])
            endDate = new Date(this.searchForm.dateRange[1])
          } else {
            // 默认显示最近30天，增加数据量来测试滚动
            startDate.setDate(today.getDate() - 30)
          }
          
          const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24))
          
          for (let i = 0; i <= daysDiff; i++) {
            const date = new Date(startDate)
            date.setDate(startDate.getDate() + i)
            
            const baseAmount = 1000 + Math.random() * 5000
            const timeoutAmount = baseAmount * 0.1 + Math.random() * 500
            const settledAmount = baseAmount * 0.8 + Math.random() * 1000
            const settledTimeoutAmount = timeoutAmount * 0.7 + Math.random() * 100
            
            data.push({
              date: date.toISOString().split('T')[0],
              totalOrderAmount: baseAmount.toFixed(2),
              platformShare: (baseAmount * 0.2).toFixed(2),
              propertyShare: (baseAmount * 0.5).toFixed(2),
              personalShare: (baseAmount * 0.3).toFixed(2),
              totalTimeoutAmount: timeoutAmount.toFixed(2),
              timeoutPlatformShare: (timeoutAmount * 0.2).toFixed(2),
              timeoutPropertyShare: (timeoutAmount * 0.5).toFixed(2),
              timeoutPersonalShare: (timeoutAmount * 0.3).toFixed(2),
              settledOrderAmount: settledAmount.toFixed(2),
              settledTimeoutAmount: settledTimeoutAmount.toFixed(2)
            })
          }
          
          return data
        }
        
        // 根据查询条件过滤数据
        let filteredData = generateTestData()
        
        if (this.searchForm.parkId) {
          // 根据车场ID调整数据
          const parkId = this.searchForm.parkId
          filteredData = filteredData.map(item => {
            const multiplier = parkId * 0.5 + 0.5
            return {
              ...item,
              totalOrderAmount: (parseFloat(item.totalOrderAmount) * multiplier).toFixed(2),
              platformShare: (parseFloat(item.platformShare) * multiplier).toFixed(2),
              propertyShare: (parseFloat(item.propertyShare) * multiplier).toFixed(2),
              personalShare: (parseFloat(item.personalShare) * multiplier).toFixed(2),
              totalTimeoutAmount: (parseFloat(item.totalTimeoutAmount) * multiplier).toFixed(2),
              timeoutPlatformShare: (parseFloat(item.timeoutPlatformShare) * multiplier).toFixed(2),
              timeoutPropertyShare: (parseFloat(item.timeoutPropertyShare) * multiplier).toFixed(2),
              timeoutPersonalShare: (parseFloat(item.timeoutPersonalShare) * multiplier).toFixed(2),
              settledOrderAmount: (parseFloat(item.settledOrderAmount) * multiplier).toFixed(2),
              settledTimeoutAmount: (parseFloat(item.settledTimeoutAmount) * multiplier).toFixed(2)
            }
          })
        }
        
        // 分页处理
        const startIndex = (this.pagination.currentPage - 1) * this.pagination.pageSize
        const endIndex = startIndex + this.pagination.pageSize
        
        this.tableData = filteredData.slice(startIndex, endIndex)
        this.pagination.total = filteredData.length
        
        // 实际API调用（注释掉）
        // const params = {
        //   page: this.pagination.currentPage,
        //   pageSize: this.pagination.pageSize
        // }
        // 
        // if (this.searchForm.parkId) {
        //   params.parkId = this.searchForm.parkId
        // }
        // if (this.searchForm.spaceId) {
        //   params.spaceId = this.searchForm.spaceId
        // }
        // if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        //   params.startDate = this.searchForm.dateRange[0]
        //   params.endDate = this.searchForm.dateRange[1]
        // }
        // 
        // const response = await get(shareReportDayList(), params)
        // 
        // if (response.data) {
        //   this.tableData = response.data.records || []
        //   this.pagination.total = response.data.total || 0
        // }
      } catch (error) {
        console.error('获取列表数据失败:', error);
      } finally {
        this.loading = false;
        this.tableLoading = false;
      }
    },

    // 计算列总计
    calculateColumnTotal(columnProp) {
      let total = 0;
      this.tableData.forEach(row => {
        total += parseFloat(row[columnProp] || 0);
      });
      return total.toFixed(2);
    },

    // 表格底部合计行
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property === 'date') {
          sums[index] = '';
          return;
        }
        if (column.property === 'totalOrderAmount') {
          sums[index] = `¥${this.calculateColumnTotal('totalOrderAmount')}`;
        } else if (column.property === 'settledOrderAmount') {
          sums[index] = `¥${this.calculateColumnTotal('settledOrderAmount')}`;
        } else if (column.property === 'platformShare') {
          sums[index] = `¥${this.calculateColumnTotal('platformShare')}`;
        } else if (column.property === 'propertyShare') {
          sums[index] = `¥${this.calculateColumnTotal('propertyShare')}`;
        } else if (column.property === 'personalShare') {
          sums[index] = `¥${this.calculateColumnTotal('personalShare')}`;
        } else if (column.property === 'totalTimeoutAmount') {
          sums[index] = `¥${this.calculateColumnTotal('totalTimeoutAmount')}`;
        } else if (column.property === 'settledTimeoutAmount') {
          sums[index] = `¥${this.calculateColumnTotal('settledTimeoutAmount')}`;
        } else if (column.property === 'timeoutPlatformShare') {
          sums[index] = `¥${this.calculateColumnTotal('timeoutPlatformShare')}`;
        } else if (column.property === 'timeoutPropertyShare') {
          sums[index] = `¥${this.calculateColumnTotal('timeoutPropertyShare')}`;
        } else if (column.property === 'timeoutPersonalShare') {
          sums[index] = `¥${this.calculateColumnTotal('timeoutPersonalShare')}`;
        }
      });
      return sums;
    },

    // 查询
    handleSearch() {
      if (this.tableLoading) return;
      this.pagination.currentPage = 1
      this.getStatistics()
      this.getTableData()
    },

    // 重置
    handleReset() {
      this.searchForm.parkId = ''
      this.searchForm.spaceId = ''
      this.searchForm.dateRange = [] // 重置时间范围
      this.pagination.currentPage = 1
      this.getStatistics()
      this.getTableData()
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.getTableData()
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getTableData()
    },

    // 监听车场选择变化
    watchParkChange() {
      this.searchForm.spaceId = ''
      if (this.searchForm.parkId) {
        this.getSpaceList()
      } else {
        this.spaceList = []
      }
    }
  }
}
</script>

<style scoped>
/* 表格行悬停效果 */
.el-table tbody tr:hover > td {
  background: #f8f9fa !important;
}

/* 当前行高亮 */
.el-table__current-row > td {
  background-color: #e3f2fd !important;
}

/* 表格底部合计行样式 */
.el-table__footer-wrapper {
  background-color: #f8f9fa !important;
}

.el-table__footer-wrapper .el-table__footer {
  background-color: #f8f9fa !important;
}

.el-table__footer-wrapper .el-table__footer td {
  background-color: #f8f9fa !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
  border-top: 2px solid #409eff !important;
}

.el-table__footer-wrapper .el-table__footer td:first-child {
  background-color: #409eff !important;
  color: white !important;
  font-weight: 700 !important;
}

</style>
